import React from 'react';

export const PlusIcon = ({ size, props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size | 24}
    height={size | 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      className="plus"
      d="M12 12L12 6 11 6 11 12 5 12 5 13 11 13 11 19 12 19 12 13 18 13 18 12z"
    />
  </svg>
);
